export enum StaffContractEnum {
  'Part-time' = 1,
  'HDGV' = 2,
}
type StaffItemTypes = {
  id: number,
  fullname: string,
  dob: string,
  idCardNumber: string,
  idCardIssuedAt: string,
  idCardIssuedBy: string,
  taxCode: string | null,
  permanentAddress: string,
  contractType: StaffContractEnum,
  socialInsuranceNumber: string,
  socialInsuranceJoinDate: string,
  socialInsuranceImage: string | null,
  backIdCard: string | null,
  frontIdCard: string | null,
  phoneNumber: string
};

export type StaffBankDataTypes = {
  accountNumber: string,
  accountName: string,
  accountDefault: boolean,
  isActive: boolean,
  // bankCode: string,
  bankName: string,
  branchName: string,
  province?: {
    code: string,
    name: string
  },
  bankId: number
};

export type StaffResponseType = {
  staffData: StaffItemTypes & {
    socialInsuranceImagePath: string | null,
    frontIdCardPath: string | null,
    backIdCardPath: string | null
  },
  bankData: Array<StaffBankDataTypes>
};

export type StaffRequestType = Omit<StaffItemTypes, 'id' | 'contractType'> & {
  contractType: number,
  banks: Array<Omit<StaffBankDataTypes, 'bankName' | 'branchName' | 'province'> & { bankId: number }>,
  frontIdCard: string,
  backIdCard: string
};

export type OCRRequestDataTypes = {
  frontIdCardPath: string,
  backIdCardPath: string
};

export type OCRResponseDataTypes = {
  data: {
    idCardNumber: string,
    idCardName: string,
    idCardDob: string,
    idCardIssuedAt: string,
    idCardIssuedBy: string,
    idCardAddress: string
  }
};

export interface ImportDataRequestType {
  file: File,
  preview: boolean
}

export interface RowImportDataResponseType {
  fullname: string;
  dob: string
  idCardNumber: string;
  idCardIssuedAt: string;
  idCardIssuedBy: string;
  taxCode?: string;
  permanentAddress: string;
  contractType: number;
  socialInsuranceNumber: number;
  socialInsuranceJoinDate: string;
  phoneNumber: string;
  bankAccountHolder: string;
  bankAccountNumber: number;
  bankName: string;
  city: string;
  branch: string;
  rowNumber: number;
  imported: boolean;
  errors: string[];
}

export interface ImportDataResponseType {
  total: number,
  errors: number,
  rows: Array<RowImportDataResponseType>;
}

export interface StaffProjectResponse {
  staffData: {
    id: number;
    fullname: string;
  },
  payrollPeriodData: {
    id: number;
    name: string;
    startDate: string;
    endDate: string;
  },
  projectData: {
    id: number;
    name: string;
    code: string;
    customerName: string;
    fromDate: string;
    toDate: string;
  }
}
